// API Configuration
export const API_BASE_URL = 'https://api.thelivingroomloja21.com';

// Environment-based configuration
const getApiBaseUrl = () => {
  // Use production API for development - can be overridden with REACT_APP_API_URL
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'https://api.thelivingroomloja21.com';
  }
  return API_BASE_URL;
};

export const getApiUrl = () => getApiBaseUrl();

